<!--
    Summary:
        hkml.exhibition.web - media-center-pagination
    ChangeLog:
        wangn on 2020/11/29 added
-->
<template>
  <div class="v-media-center-pagination" title="media-center-pagination">
    <div class="data">
      <a target="_blank" :href="'/#/MediaCenterPage?id='+item.Id" class="item" v-for="item in pagination.data">
        <div class="img-wrapper">
          <img :src="item.FullCover">
        </div>
        <div class="info">
          <div class="title">{{item.Abstract}}</div>
          <!-- <div class="desc" v-if="isEng" >{{item.EnglishContent}}</div> -->
          <!-- <div class="desc" v-else>{{item.Content}}</div> -->
          <div class="desc" v-if="isEng" v-html="item.EnglishContent"></div>
          <div class="desc" v-else v-html="item.Content"></div>
        </div>
      </a>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="searchForm.pageSize"
        :total="pagination.totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {GetNotices} from '../../../service/searchreport'

  export default {
    name: "media-center-pagination",
    data() {
      return {
        searchForm: {
          pageIndex: 1,
          pageSize: 6,
        },
        pagination: {
          totalCount: 0,
          data: []
        }
      }
    },
    mounted() {
      this.getData();
    },
    computed: {
      isEng: function () {
        return this.$i18n.locale == 'en-US';
      }
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.searchForm.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.searchForm.pageIndex = val;
        this.getData();
      },
      async getData() {
        var searchForm = this.searchForm;
        let resp = await GetNotices(searchForm.pageIndex, searchForm.pageSize);

        let data = resp.Data;
        data.map(item => {
          item.PublishTime = this.formatDate(item.PublishTime);
          item.FullCover = process.env.BASE_URL + item.Cover;
        });
        this.pagination.totalCount = resp.TotalCount;
        this.pagination.data = data;
      },
      formatDate(dateStr) {
        if (!dateStr) return dateStr;
        try {
          let date = new Date(dateStr);
          let day = date.getDate(), month = date.getMonth() + 1, year = date.getFullYear();

          if (day < 10) day = '0' + day;
          if (month < 10) day = '0' + month;
          return day + '-' + month + '-' + year;
        } catch (ex) {
        }
        return dateStr;
      },
    },
  }
</script>

<style scoped lang="scss">
  .v-media-center-pagination {
    padding: 5vw 15vw 3vw;
    text-align: left;

    .data {
      margin-bottom: 1.5vw;

      .item {
        height: 12.5vw;
        &:hover {
          .title {
            color: #38a2b4;
          }
        }

        margin-bottom: 3vw;
        text-decoration: none;
        display: flex;
        justify-content: space-between;

        .img-wrapper {
          margin-right: 2vw;

          img {
            border: 1px solid #ccc;
            width: 19.27vw;
            height: 12.5vw;
            object-fit: cover;
          }
        }

        .info {
          flex-grow: 1;
          max-width: 48vw;
          overflow: hidden;
          .title {
            font-weight: bold;
            font-size: 2.66vw;
            line-height: 3.13vw;
            color: #273a63;
            white-space: nowrap;
            overflow: hidden;
          }

          .time {
            font-size: 0.94vw;
            line-height: 1.67vw;
          }
        }
      }

    }

    .pagination-wrapper {
      text-align: center;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/news/media-center/media-center-pagination.vue